import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable, take } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';
import { RegistrationStatus } from '../models/panel-members/registration-status.interface';

@Injectable({ providedIn: 'root' })
export class RegistrationStatusService {
  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  isEmailVerified(): Observable<boolean> {
    return this.http.get<boolean>(`${this.environment.endPoint}panel-member/email-verified`);
  }

  profilesStatus(): Observable<RegistrationStatus> {
    return this.http.get<RegistrationStatus>(`${this.environment.endPoint}panel-member/registration/status`);
  }

  getPendingProfileSurvey(): Observable<{ id: string }> {
    return this.http.get<{ id: string }>(`${this.environment.endPoint}project/profile/next`).pipe(take(1));
  }
}
